import React, { FC } from 'react';

import Button from '@adsk/alloy-react-button';
import { noop } from '@adsk/alloy-react-helpers';
import Modal from '@adsk/alloy-react-modal';

import { useTranslation } from './i18n';
import { CommonReferencePickerPlugin } from './types/ReferencePickerPlugin';
import { EntityWithId } from './types/types';

interface RemoveConfirmationModalProps {
  plugin?: CommonReferencePickerPlugin;
  entity?: EntityWithId;
  container?: unknown;
  closeConfirmRemoveModal: () => void;
  onRemove: () => void;
  isRemoving?: boolean;
}

const RemoveConfirmationModal: FC<RemoveConfirmationModalProps> = ({
  plugin,
  entity,
  container,
  closeConfirmRemoveModal,
  onRemove,
  isRemoving,
}) => {
  const { t } = useTranslation();
  const show = !!entity && !!plugin;

  const Title = plugin?.CustomRemoveEntityModalTitle;
  const Content = plugin?.CustomRemoveEntityModalContent;

  return (
    <Modal
      open={show}
      onClose={isRemoving ? noop : closeConfirmRemoveModal}
      container={container}
      size={Modal.SIZES.SMALL}
      height="auto"
    >
      <Modal.Header
        style={{
          borderBottom: 0,
        }}
      >
        {Title && entity ? <Title entity={entity} /> : t('REMOVE_LINK_TITLE')}
        <Modal.Close onClick={closeConfirmRemoveModal} disabled={isRemoving} />
      </Modal.Header>
      <Modal.Body>
        {Content && entity ? (
          <Content entity={entity} />
        ) : (
          t('REMOVE_LINK_MESSAGE')
        )}
      </Modal.Body>
      <Modal.Footer disableBorder>
        <Button
          style={{
            marginRight: 8,
          }}
          onClick={closeConfirmRemoveModal}
          disabled={isRemoving}
        >
          {t('CANCEL')}
        </Button>
        <Button
          variant={Button.VARIANTS.PRIMARY}
          onClick={onRemove}
          loading={isRemoving}
          alert={true}
        >
          {t('REMOVE')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveConfirmationModal;
